<div class="pad-5 border-t border-c mob-mar-b-15 font-10">
  <div class="rt-trans-container " [class.rt-expanded]="expanded">
    <div class="rt-trans border-r-4 pointer pos-r" matRipple>
      <ng-container *ngIf=" !!rateInfo?.zo && !!rateInfo?.zo?.id">
        <div class="rt-trans-loc overflow-e" matTooltip="Delivery Zip">
          {{(rateInfo.zo?.location_name +' - '+rateInfo.zo?.location_code) | uppercase}}</div>
        <div class="divider div-truck "></div>
        <span class="material-symbols-outlined icon-16 sub-c loc-icon-con" matTooltip="Drayage">local_shipping</span>
        <div class="divider div-truck"></div>
      </ng-container>
      <ng-container *ngIf="!!rateInfo?.origin_icd">
        <div class="rt-trans-loc overflow-e" matTooltip="ICD/Ramp">{{rateInfo?.origin_icd?.value}}</div>
        <div class="divider div-inland "></div>
        <span class="material-symbols-outlined icon-16 sub-c loc-icon-con " matTooltip="Pre-carriage">bus_railway</span>
        <div class="divider div-inland "></div>
      </ng-container>
      <div class="rt-trans-loc overflow-e" matTooltip="POL">{{rateInfo?.pol?.value}}({{rateInfo?.pol?.unlocode}})</div>
      <div class="divider div-port "></div>
      <span class="material-symbols-outlined icon-16 sub-c loc-icon-con" matTooltip="Ocean trans">directions_boat</span>
      <div class="divider div-port "></div>
      <div class="rt-trans-loc overflow-e" matTooltip="POD">{{rateInfo?.pod?.value}}({{rateInfo?.pod?.unlocode}})</div>
      <ng-container *ngIf="!!rateInfo?.fd">
        <div class="divider div-inland "></div>
        <span class="material-symbols-outlined icon-16 sub-c loc-icon-con">bus_railway</span>
        <div class="divider div-inland "></div>
        <div class="rt-trans-loc overflow-e" matTooltip="FD">{{rateInfo?.fd?.value}}({{rateInfo?.fd?.unlocode}})</div>
      </ng-container>
      <ng-container *ngIf="!!rateInfo?.destination_icd">
        <div class="divider div-inland "></div>
        <span class="material-symbols-outlined icon-16 sub-c loc-icon-con" matTooltip="On-carriage">bus_railway</span>
        <div class="divider div-inland "></div>
        <div class="rt-trans-loc overflow-e" matTooltip="ICD/Ramp">{{rateInfo?.destination_icd?.value}}</div>
      </ng-container>
      <ng-container *ngIf="!!rateInfo?.zd && !!rateInfo?.zd?.id && showTrucking">
        <div class="divider div-truck "></div>
        <span class="material-symbols-outlined icon-16 sub-c loc-icon-con" matTooltip="Drayage">local_shipping</span>
        <div class="divider div-truck"></div>
        <div class="rt-trans-loc overflow-e" matTooltip="Delivery Zip">
          {{(rateInfo.zd?.location_name +' - '+rateInfo.zd?.location_code) | uppercase}}</div>
      </ng-container>
      <div class="pos-a pad-2 s-more-b align-c justify-c border-r-4 bg-white border border-c pointer"
        style="right: 5px;top:5px" (click)="toggleExpanded($event)"
        [attr.aria-label]="expanded ? 'Show less of the route' : 'Show the full route'" role="button">
        <span class="material-symbols-outlined icon-20 ">{{ expanded ? 'remove' : 'add' }}</span>
        <span class="desk-view">{{ expanded ? 'Less' : 'More' }}</span>
      </div>
    </div>
  </div>
</div>
